// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8f4f3479","651":"b36e27a0","703":"8c29c9ba","787":"0321758c"}[chunkId] + ".chunk.js";
};